

const CommonHeaders = () => {
    return {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("session_id"),
      },
    };
  };

  export default CommonHeaders